










































import { ShortTypeBadge } from '@/app/components';
import { XIcon } from '@vue-hero-icons/outline';
import { defineComponent, PropType } from '@vue/composition-api';

import { S } from '@/app/utilities';

export default defineComponent({
    name: 'ColumnMetricsTabMenu',
    props: {
        options: {
            type: Array as PropType<{ key: string; name: string; type: string }[]>,
            required: true,
        },
        activeTab: {
            type: String,
            required: true,
        },
    },
    components: { ShortTypeBadge, XIcon },
    setup(props: any, { emit }: { emit: any }) {
        const changeTab = (tab: string) => {
            if (props.activeTab && tab !== props.activeTab) emit('change-tab', tab);
        };

        return {
            S,
            changeTab,
        };
    },
});
